import { Button } from 'antd';
import BankSlipGenerateRemittanceModal, {
  GenerateRemittanceFormValues,
} from './BankSlipGenerateRemittanceModal';
import useReportGenerate, { ReportCallback } from '@/hooks/useReportGenerate';
import { useDisclosure } from '@/hooks';
import { useGenerateRemmitanceBankSlip } from '@/core/domain/financial/Boletos/Boletos.hooks';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import moment from 'moment';
import { useBankSlipFormContext } from '@/pages/FinancialPages/BankSlipPage';

export default function GenerateRemmitanceButton() {
  const { queryParams, selectedBankSlips } = useBankSlipFormContext();
  const [generateRemittance, generateRemittanceAction] = useDisclosure();

  const generateRemmitanceMutation = useGenerateRemmitanceBankSlip();

  const report = useReportGenerate();

  const handleGenerateRemittance = async (
    values: GenerateRemittanceFormValues,
    callback?: ReportCallback,
  ) => {
    if (values) {
      const result = await generateRemmitanceMutation.mutateAsync({
        companyId: values.companyId,
        installmentReceivableBillIds: selectedBankSlips.map((item) => item.id),
      });

      if (callback) {
        callback(result);
      }

      generateRemittanceAction.close();
    }
  };
  return (
    <>
      <Button
        type="primary"
        block
        onClick={generateRemittanceAction.open}
        disabled={
          !selectedBankSlips.length ||
          !hasPermissions([Authorities.FINANCIAL_BILL_GENERATE_REMITTANCE_FILE])
        }
      >
        Gerar arquivo remessa
      </Button>

      <BankSlipGenerateRemittanceModal
        onCallback={(values) =>
          handleGenerateRemittance(values, (result) =>
            report.downloadFile({
              result,
              fileName: `remessa_${moment().format('DD-MM-YYYY')}.zip`,
            }),
          )
        }
        open={generateRemittance}
        onCancel={generateRemittanceAction.close}
        loading={generateRemmitanceMutation.isLoading}
        companyId={queryParams.companyId}
      />
    </>
  );
}
